import { render, staticRenderFns } from "./materi.vue?vue&type=template&id=1838011f&scoped=true"
import script from "./materi.vue?vue&type=script&lang=js"
export * from "./materi.vue?vue&type=script&lang=js"
import style0 from "./materi.vue?vue&type=style&index=0&id=1838011f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838011f",
  null
  
)

export default component.exports